export default __webpack_public_path__ + "static/slapjums-9f686e99d88317adc519338b00a670cf.jpg";